(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["torrins-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('torrins-delivery-estimate')) {
    const STORAGE_KEY = 'torrins-pincode';
    const CACHE_KEY = 'torrins-delivery-cache';
    const CACHE_MAX_ENTRIES = 10;
    const PINCODE_PATTERN = /^[1-9]\d{5}$/;
    /** Requests in flight on this page, shared by all delivery blocks. @type {Map<string, Promise<Object>>} */
    const pending = new Map();

    const readCache = () => {
      try {
        return JSON.parse(window.localStorage.getItem(CACHE_KEY) || '{}') || {};
      } catch {
        return {};
      }
    };

    const writeCache = (pincode, data) => {
      try {
        const cache = readCache();
        cache[pincode] = { data, savedAt: Date.now() };
        const newest = Object.entries(cache)
          .sort(([, a], [, b]) => b.savedAt - a.savedAt)
          .slice(0, CACHE_MAX_ENTRIES);
        window.localStorage.setItem(CACHE_KEY, JSON.stringify(Object.fromEntries(newest)));
      } catch {}
    };

    class TorrinsDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[name="pincode"]');
        this.button = this.querySelector('button[type="submit"]');
        this.result = this.querySelector('.torrins-delivery__result');
        if (!this.form || !this.input || !this.button || !this.result) return;

        this.input.addEventListener('input', () => {
          this.input.value = this.input.value.replace(/\D/g, '').slice(0, 6);
        });
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.check(this.input.value.trim());
        });

        let saved = null;
        try {
          saved = window.localStorage.getItem(STORAGE_KEY);
        } catch {}
        if (saved && PINCODE_PATTERN.test(saved)) {
          this.input.value = saved;
          this.check(saved);
        }
      }

      get cacheTtl() {
        const hours = Number(this.dataset.cacheHours) || 24;
        return hours * 60 * 60 * 1000;
      }

      /**
       * Cached API answer for a pincode, if it is younger than the cache lifetime.
       * @param {string} pincode
       * @returns {Object | null}
       */
      cached(pincode) {
        const entry = readCache()[pincode];
        if (!entry || !entry.data || Date.now() - entry.savedAt >= this.cacheTtl) return null;
        return entry.data;
      }

      /**
       * One API request per pincode per page; successful answers are cached in localStorage.
       * Resolves with the API JSON; rejects on network errors. API "error" answers are returned but not cached.
       * @param {string} pincode
       * @returns {Promise<Object>}
       */
      request(pincode) {
        if (pending.has(pincode)) return pending.get(pincode);

        const url = new URL(this.dataset.apiUrl);
        url.searchParams.set('pincode', pincode);
        const promise = fetch(url.toString(), { headers: { accept: 'application/json' } })
          .then(async (response) => {
            const data = await response.json().catch(() => null);
            if (data && data.error && !data.serviceable) return data;
            if (!response.ok || !data) throw new Error(String(response.status));
            writeCache(pincode, data);
            return data;
          })
          .finally(() => pending.delete(pincode));

        pending.set(pincode, promise);
        return promise;
      }

      async check(pincode) {
        if (!PINCODE_PATTERN.test(pincode)) {
          this.show('error', [this.dataset.textInvalid]);
          return;
        }

        try {
          window.localStorage.setItem(STORAGE_KEY, pincode);
        } catch {}

        const cached = this.cached(pincode);
        if (cached) {
          this.render(pincode, cached);
          return;
        }

        if (this.button.getAttribute('aria-busy') === 'true') return;
        this.button.setAttribute('aria-busy', 'true');
        this.button.disabled = true;
        this.input.readOnly = true;
        if (this.result.childElementCount > 0) {
          this.result.dataset.loading = 'true';
        } else {
          this.show('muted', [this.dataset.textLoading]);
        }
        try {
          this.render(pincode, await this.request(pincode));
        } catch {
          this.show('error', [this.dataset.textError]);
        } finally {
          this.button.removeAttribute('aria-busy');
          this.button.disabled = false;
          this.input.readOnly = false;
          delete this.result.dataset.loading;
        }
      }

      /**
       * @param {string} pincode
       * @param {Object} data - API response
       */
      render(pincode, data) {
        // API reported a problem: show its own message.
        if (data.error && !data.serviceable) {
          this.show('error', [String(data.error)]);
          return;
        }

        if (!data.serviceable) {
          const template = (this.dataset.textUnserviceable || '').replace('[pincode]', '[value]');
          this.show('muted', [template.includes('[value]') ? [template, pincode] : template]);
          return;
        }

        const lines = [];
        if (data.label) lines.push([this.dataset.textServiceable, data.label]);
        const date = this.expectedDate(data);
        if (date) lines.push([this.dataset.textEdd, date]);
        this.show('success', lines);
      }

      /**
       * Delivery date: the API's edd when present, otherwise today + expected_delivery days.
       * Delhivery doesn't deliver on Sundays, so a Sunday moves to Monday.
       * @param {Object} data - API response (uses edd and expected_delivery)
       * @returns {string | null} e.g. "Monday, 26 May"
       */
      expectedDate(data) {
        let date = null;
        if (data.edd) {
          const edd = new Date(data.edd);
          if (!Number.isNaN(edd.getTime())) date = edd;
        }
        const days = Number(data.expected_delivery);
        if (!date && Number.isFinite(days) && days >= 0) {
          date = new Date();
          date.setDate(date.getDate() + days);
        }
        if (!date) return null;
        if (date.getDay() === 0) date.setDate(date.getDate() + 1);
        return date.toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'long' });
      }

      /**
       * @param {string} state - success | muted | error
       * @param {Array<string | [string, string]>} lines - plain text, or [template, value] where [value] is shown in bold
       */
      show(state, lines) {
        this.result.dataset.state = state;
        this.result.replaceChildren(
          ...lines.filter(Boolean).map((entry) => {
            const line = document.createElement('p');
            if (Array.isArray(entry)) {
              const [template = '', value = ''] = entry;
              const [before, after = ''] = template.split('[value]');
              const strong = document.createElement('strong');
              strong.textContent = value;
              line.append(before, strong, after);
            } else {
              line.textContent = entry;
            }
            return line;
          })
        );
      }
    }

    customElements.define('torrins-delivery-estimate', TorrinsDeliveryEstimate);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["torrins-pair-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('torrins-pair-products')) {
    class TorrinsPairProducts extends HTMLElement {
      connectedCallback() {
        try {
          this.mainPrices = JSON.parse(this.querySelector('[data-main-prices]')?.textContent || '{}');
        } catch {
          this.mainPrices = {};
        }
        this.button = this.querySelector('[data-pair-add]');
        this.error = this.querySelector('[data-pair-error]');

        this.addEventListener('change', this.#onChange);
        this.button?.addEventListener('click', this.#onAdd);
        // The main product's variant picker lives outside this block.
        document.addEventListener('change', this.#onPageChange);
        this.#update();
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.#onPageChange);
      }

      get rows() {
        return [...this.querySelectorAll('[data-pair-row]')];
      }

      /** Variant id currently selected in Horizon's product form (falls back to the server-rendered one). */
      get mainVariantId() {
        const input = document.querySelector('product-form-component input[name="id"]');
        return (input instanceof HTMLInputElement && input.value) || this.dataset.mainVariantId;
      }

      #onChange = () => this.#update();

      #onPageChange = (event) => {
        if (!this.contains(/** @type {Node} */ (event.target))) setTimeout(() => this.#update(), 0);
      };

      /** @param {number} cents */
      #money(cents) {
        const format = this.dataset.moneyFormat || '';
        const value = cents / 100;
        const patterns = {
          amount: () => value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          amount_no_decimals: () => Math.round(value).toLocaleString('en-US'),
          amount_with_comma_separator: () =>
            value.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          amount_no_decimals_with_comma_separator: () => Math.round(value).toLocaleString('de-DE'),
        };
        const match = format.match(/\{\s*\{\s*(\w+)\s*\}\s*\}/);
        if (!match) return value.toFixed(2);
        const formatted = (patterns[match[1]] || patterns.amount)();
        return format.replace(match[0], formatted);
      }

      /** @param {HTMLElement} row */
      #rowVariant(row) {
        const field = row.querySelector('[data-pair-variant]');
        let source = null;
        if (field instanceof HTMLSelectElement) source = field.selectedOptions[0];
        else if (field instanceof HTMLInputElement) source = field;
        if (!source || !(field instanceof HTMLSelectElement || field instanceof HTMLInputElement)) {
          return { id: '', price: 0, compare: 0 };
        }
        return {
          id: field.value,
          price: Number(source.dataset.price || 0),
          compare: Number(source.dataset.compare || 0),
        };
      }

      /** @param {number} price @param {number} percent */
      #discounted(price, percent) {
        return Math.round((price * (100 - percent)) / 100);
      }

      /** Fills a "[percent]% off" badge from price vs original; hidden when there is no saving. */
      #setBadge(badge, price, original) {
        if (!(badge instanceof HTMLElement)) return;
        const percent = original > price ? Math.round(((original - price) / original) * 100) : 0;
        badge.textContent = (badge.dataset.template || '').replace('[percent]', String(percent));
        badge.hidden = percent < 1;
      }

      #update() {
        const [mainPrice = 0, mainCompare = 0] = this.mainPrices[this.mainVariantId] || [];
        const mainPriceEl = this.querySelector('[data-main-price]');
        const mainCompareEl = this.querySelector('[data-main-compare]');
        if (mainPriceEl && mainPrice) mainPriceEl.textContent = this.#money(mainPrice);
        if (mainCompareEl) {
          mainCompareEl.textContent = mainCompare > mainPrice ? this.#money(mainCompare) : '';
          mainCompareEl.hidden = !(mainCompare > mainPrice);
        }
        this.#setBadge(this.querySelector('[data-main-badge]'), mainPrice, mainCompare);

        let total = mainPrice;
        let original = Math.max(mainPrice, mainCompare);
        let checked = 0;
        for (const row of this.rows) {
          const { price, compare } = this.#rowVariant(row);
          const percent = Number(row.dataset.discountPercent || 0);
          const finalPrice = percent > 0 ? this.#discounted(price, percent) : price;
          const rowOriginal = Math.max(price, compare);

          const priceEl = row.querySelector('[data-pair-price]');
          if (priceEl) priceEl.textContent = this.#money(finalPrice);
          const compareEl = row.querySelector('[data-pair-compare]');
          if (compareEl) compareEl.textContent = rowOriginal > finalPrice ? this.#money(rowOriginal) : '';

          const box = row.querySelector('[data-pair-check]');
          if (box instanceof HTMLInputElement && box.checked) {
            total += finalPrice;
            original += rowOriginal;
            checked += 1;
          }
        }

        const totalEl = this.querySelector('[data-pair-total]');
        if (totalEl) totalEl.textContent = this.#money(total);
        const totalCompareEl = this.querySelector('[data-pair-total-compare]');
        if (totalCompareEl) {
          totalCompareEl.textContent = original > total ? this.#money(original) : '';
          totalCompareEl.hidden = !(original > total);
        }
        this.#setBadge(this.querySelector('[data-pair-total-badge]'), total, original);
        if (this.button) this.button.disabled = checked === 0;
      }

      #onAdd = async () => {
        if (!this.button || this.button.getAttribute('aria-busy') === 'true') return;

        const items = [{ id: Number(this.mainVariantId), quantity: 1 }];
        for (const row of this.rows) {
          const box = row.querySelector('[data-pair-check]');
          const { id } = this.#rowVariant(row);
          if (box instanceof HTMLInputElement && box.checked && id) items.push({ id: Number(id), quantity: 1 });
        }
        if (items.length < 2) return;

        this.button.setAttribute('aria-busy', 'true');
        if (this.error) this.error.hidden = true;
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          const data = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
          window.location.assign(`${root}cart`);
        } catch (error) {
          if (this.error) {
            this.error.textContent = error instanceof Error ? error.message : String(error);
            this.error.hidden = false;
          }
          this.button.removeAttribute('aria-busy');
        }
      };
    }

    customElements.define('torrins-pair-products', TorrinsPairProducts);
  }
  } catch(e) { console.error(e); }
})();

})();
